// extracted by mini-css-extract-plugin
export default {"footer":"L_cr","footer_logo":"L_cs","navLinks":"L_ct","column":"L_cv","columnHeading":"L_cw","copyright":"L_cx","socialMediaLinks":"L_cy"};